import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMetric from './metric.reducer';

export const selectMetricState = createFeatureSelector<fromMetric.State>(fromMetric.metricFeatureKey);

export const selectMetrics = createSelector(selectMetricState, (state) => state.datasourceMetrics);
export const selectIsMetricsLoading = createSelector(selectMetricState, (state) => state.isDatasourceMetricsLoading);
export const selectIsMetricsComplete = createSelector(selectMetricState, (state) => state.isDatasourceMetricsComplete);
export const selectIsMetricsRunComplete = createSelector(selectMetricState, (state) => state.isMetricsRunComplete);
export const metricsError = createSelector(selectMetricState, (state) => state.datasourceMetricsError);

// TODO: Stop hardcoding this metric selector and get it from selected query state
export const selectMetricToken = createSelector(selectMetricState, (state) => state.selectedMetric);
export const selectMetricVizType = createSelector(selectMetricState, (state) => state.selectedVizType);
export const selectSelectedQueryRawSql = createSelector(selectMetricState, (state) => state.selectedQueryRawSql);

export const selectNames = createSelector(selectMetricState, (state) => state.names);
export const selectSqls = createSelector(selectMetricState, (state) => state.sqls);
export const selectTypes = createSelector(selectMetricState, (state) => state.types);
export const selectChartStates = createSelector(selectMetricState, (state) => state.chartStates);

export function createMetricNameSelector(metricToken: string) {
  return createSelector(selectNames, (names) => names.get(metricToken));
}

export function createMetricSqlSelector(metricToken: string) {
  return createSelector(selectSqls, (sqls) => sqls.get(metricToken));
}

export function createMetricTypeselector(metricToken: string) {
  return createSelector(selectTypes, (types) => types.get(metricToken));
}

export function createMetricChartStateSelector(token: string) {
  return createSelector(selectChartStates, (state) => state.get(token));
}
